var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { animated } from '@react-spring/web';
import styled from 'styled-components';
import cx from 'classnames';
import { Close } from 'styled-cssgg';
const StyledCloseIcon = styled(animated.span) `
  --ggs: 0.5;
  cursor: pointer;
  border-radius: 100%;
  color: ${() => 'var(--text-color-0)'};
  background-color: ${() => 'var(--bg-color)'};
  position: ${(props) => props.position};
  right: ${(props) => props.right && `${props.right}px`};
  top: ${(props) => props.top && `${props.top}px`};
  left: ${(props) => props.left && `${props.left}px`};
  bottom: ${(props) => props.bottom && `${props.bottom}px`};
  z-index: 1000;
  pointer-events: all;
`;
export const CloseIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    const handleClose = useCallback((e) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [onClick]);
    return (React.createElement(StyledCloseIcon, Object.assign({ className: cx('close-icon', props.className), "data-role": "close-icon", onClick: handleClose }, props),
        React.createElement(Close, null)));
};
